<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">playlist_add_check</v-icon>
          Order-Detail
        </h3>
        You have the option to filter the items to your needs. The sort order
        can be changed by clicking the switches in the header.
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-5 pb-0 elevation-3>
      <v-flex xs12>
        <order-status-head></order-status-head>
      </v-flex>
    </v-layout>
    <v-layout row wrap my-5 pb-0>
      <v-flex xs12>
        <order-status-items></order-status-items>
      </v-flex>
      <v-flex xs12 mt-2 text-xs-left>
        <v-btn class="mr-0" outline color="grey" dark to="/order_status">
          <v-icon small class="pr-2">chevron_left</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderStatusItems from "@/components/OrderStatusItems.vue";
import OrderStatusHead from "@/components/OrderStatusHead.vue";

export default {
  components: {
    OrderStatusItems,
    OrderStatusHead
  }
};
</script>
